import { useMutation, useQueryClient, mutationOptions } from '@tanstack/react-query';

import { updateCompanyProfile } from '../../api/companyProfileService';

import { companyProfileKeys, companyProfileMutationKeys } from './keys';

export const saveCompanyProfileOptions = (queryClient) =>
	mutationOptions({
		mutationKey: companyProfileMutationKeys.save,
		mutationFn: ({ updates }) => updateCompanyProfile({ updates }),
		onMutate: async ({ updates }) => {
			await queryClient.cancelQueries({ queryKey: companyProfileKeys.detail() });

			const previousProfile = queryClient.getQueryData(companyProfileKeys.detail());

			queryClient.setQueryData(companyProfileKeys.detail(), (old) => {
				if (!old) return updates;
				return { ...old, ...updates };
			});

			return { previousProfile };
		},
		onError: (err, variables, context) => {
			if (context?.previousProfile) {
				queryClient.setQueryData(companyProfileKeys.detail(), context.previousProfile);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: companyProfileKeys.detail() });
		},
	});

export function useSaveCompanyProfile() {
	const qc = useQueryClient();
	return useMutation(saveCompanyProfileOptions(qc));
}
